import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=1174f0d2&scoped=true"
import script from "./activity-list.vue?vue&type=script&lang=ts"
export * from "./activity-list.vue?vue&type=script&lang=ts"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=1174f0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1174f0d2",
  null
  
)

export default component.exports